// extracted by mini-css-extract-plugin
export default {"description":"Theme_description__UqyyD"};